import { Injectable } from '@angular/core';
import { HttpService } from '../../../utils/services/http.service';
import { Observable } from 'rxjs/Observable';
import { Headers, Http, RequestOptions, Response, URLSearchParams } from '@angular/http';
import { SessionStorage } from 'ngx-webstorage';
import { ErrorsService } from '../../../utils/services/errors.service';

@Injectable()
export class AddTaskService {
  @SessionStorage() public user;

  constructor(private httpService: HttpService,
    private errorsService: ErrorsService) {
  }

  /* Function to add activity */
  addTask(data: any): Observable<any> {
    return this.httpService.post(`activity`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /* Function to upload CSV */
  uploadCSV(activity: any): Observable<any> {
    const headers = new Headers();
    headers.append('Accept', 'application/json, text/csv,');
    headers.append('Empname', this.user.Empname);
    headers.append('EmailID', this.user.EmailID);
    const options = new RequestOptions({ headers: headers });
    return this.httpService.post(`activity`, activity, options)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /* Function to get activity */
  getTask() {
    return this.httpService.get(`activity/ActivityList`)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /* Function to get upload history */
  uploadHistory() {
    const data = { 'type': 'activity' };
    return this.httpService.post(`listfileUploadHist`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /* Function to handle error data */
  handleError(error: any) {
    this.errorsService.handleError(error);
    return Observable.throw(error.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/tasks/add-task/add-task.service.ts